import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FocusActiveCerclePictoProps extends pictoProps {
}

export interface FocusActiveCerclePictoState extends pictoState {
}

export class FocusActiveCerclePicto extends Picto<FocusActiveCerclePictoProps,FocusActiveCerclePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.focusActiveCerclePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FocusActiveCerclePicto);
